module.exports = __webpack_public_path__ + "img/product-shot_01.b257dbb4.jpg";